import React from 'react';
import Head from 'next/head';
import { serializeJsonLd } from '../../utils/helpers/serializeJsonLd';

interface JsonLdProps {
  data: object;
  dataCy?: string;
}

export const JsonLd: React.FC<JsonLdProps> = ({ data, dataCy }) => (
  <Head>
    <script
      type="application/ld+json"
      data-cy={dataCy}
      dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
    />
  </Head>
);
